import BankTransfer from "@zenith/assets/icons/components/BankTransfer";
import Cash from "@zenith/assets/icons/components/Cash";
import LinkIcon from "@zenith/assets/icons/components/Link";
import Scan from "@zenith/assets/icons/components/Scan";
import StaticAccount from "@zenith/assets/icons/components/StaticAccount";
import USSD from "@zenith/assets/icons/components/USSD";

export enum PaymentMethodsEnum {
  CASH,
  USSD,
  QR_CODE_PAYMENT,
  BANK_TRANSFER,
  PAYMENT_LINK,
  STATIC_ACCOUNT,
}

export const PaymentMethodsButtons = [
  {
    index: PaymentMethodsEnum.CASH,
    text: "Cash",
    icon: Cash,
  },
  {
    index: PaymentMethodsEnum.STATIC_ACCOUNT,
    text: "Static Account",
    icon: StaticAccount,
  },
  {
    index: PaymentMethodsEnum.BANK_TRANSFER,
    text: "Pay With Transfer",
    icon: BankTransfer,
  },
  {
    index: PaymentMethodsEnum.USSD,
    text: "USSD",
    icon: USSD,
  },
  {
    index: PaymentMethodsEnum.QR_CODE_PAYMENT,
    text: "QR Code",
    icon: Scan,
  },

  {
    index: PaymentMethodsEnum.PAYMENT_LINK,
    text: "Payment Link",
    icon: LinkIcon,
  },
];
